<script lang="ts" setup>
// #上方兩張圖片，右寬左窄；下方兩張圖片，左寬右窄
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()
const imgData3 = ref()
const imgData4 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_lft_top)
  const img2: Ref<Image> = ref(props.data.image_rgt_top)
  const img3: Ref<Image> = ref(props.data.image_lft_bottom)
  const img4: Ref<Image> = ref(props.data.image_rgt_bottom)
  imgData1.value = img1.value
  imgData2.value = img2.value
  imgData3.value = img3.value
  imgData4.value = img4.value
}
</script>

<template>
  <div class="area">
    <div class="area__top">
      <figure class="area__pic1">
        <Nimg :src="imgData1?.link" :title="imgData1?.title" :alt="imgData1?.alt" format="webp" />
      </figure>
      <figure class="area__pic2">
        <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
      </figure>
    </div>
    <div class="area__bottom">
      <figure class="area__pic3">
        <Nimg :src="imgData3.link" :title="imgData3.title" :alt="imgData3.alt" format="webp" />
      </figure>
      <figure class="area__pic4">
        <Nimg :src="imgData4.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
      </figure>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  img {
    display: block;
    width: 100%;
  }

  &__top,
  &__bottom {
    display: flex;
    justify-content: space-between;

    @include max-media(480) {
      flex-direction: column;
    }
  }

  &__top {
    @include min-media(481) {
      margin-bottom: toRem(22);
    }
  }

  &__pic1 {
    width: calc(39% - toRem(11));

    @include max-media(480) {
      width: 50%;
      margin-bottom: toRem(22);
    }
  }

  &__pic2 {
    width: calc(61% - toRem(11));

    @include max-media(480) {
      width: 100%;
      margin-bottom: toRem(22);
    }
  }

  &__pic3 {
    width: calc(61% - toRem(11));

    @include max-media(480) {
      width: 100%;
      margin-bottom: toRem(22);
    }
  }

  &__pic4 {
    width: calc(39% - toRem(11));

    @include max-media(480) {
      width: 50%;
      margin-left: auto;
    }
  }
}
</style>
